<template>
  <div class="ts-p-3 ts-rounded">
    <div>
      <div class="ts-grid ts-grid-cols-1 xl:ts-grid-cols-4 ts-gap-3">
        <div class="ts-flex ts-space-x-3">
          <p>{{ $t('productProfile.replacement#') }}:</p>
          <p class="ts-text-blue-600">
            <strong>{{ value.replacement_number }}</strong>
          </p>
        </div>
        <div class="ts-flex ts-space-x-3">
          <p>{{ $t('productProfile.replacementDate') }}</p>
          <p class="ts-text-yellow-600">
            <strong>{{ value.replacement_date }}</strong>
          </p>
        </div>
        <div class="ts-flex ts-space-x-3">
          <p>{{ $t('productProfile.serial#') }}:</p>
          <p>
            <strong>{{ value.serial_no }}</strong>
          </p>
        </div>
        <div class="ts-flex ts-space-x-3">
          <p>{{ $t('productProfile.replaceBy') }} :</p>
          <p>
            <strong>{{ value.created_by }}</strong>
          </p>
        </div>
        <div class="ts-flex ts-space-x-3">
          <p>{{ $t('productProfile.remark') }}:</p>
          <p>
            {{ value.remarks }}
          </p>
        </div>
      </div>
      <table class="ts-w-full">
        <thead>
          <tr>
            <th class="ts-bg-blue-100 ts-px-2 ts-py-1 ts-w-6">
              {{ $t('productProfile.no') }}
            </th>
            <th class="ts-bg-blue-100 ts-px-2 ts-py-1 ts-w-1/3">
              {{ $t('productProfile.productName') }}
            </th>
            <th class="ts-bg-blue-100 ts-px-2 ts-py-1 ts-w-16 ts-text-center">
              {{ $t('productProfile.uom') }}
            </th>
            <th class="ts-bg-blue-100 ts-px-2 ts-py-1 ts-w-32 ts-text-center">
              {{ $t('productProfile.quantity') }}
            </th>
            <th class="ts-bg-blue-100 ts-px-2 ts-py-1 ts-w-32 ts-text-center">
              {{ $t('productProfile.cost') }}
            </th>
            <th class="ts-bg-blue-100 ts-px-2 ts-py-1 ts-w-32 ts-text-center">
              {{ $t('productProfile.totalCost') }}
            </th>
            <th class="ts-bg-blue-100 ts-px-2 ts-py-1">
              {{ $t('productProfile.remark') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(detail, index) in value.replacement_details" :key="index">
            <td class="ts-bg-gray-100 ts-px-2 ts-py-1">{{ index + 1 }}</td>
            <td class="ts-bg-gray-100 ts-px-2 ts-py-1">
              {{ detail.product_name_en }}
            </td>
            <td class="ts-bg-gray-100 ts-px-2 ts-py-1 ts-text-center">
              {{ detail.uom_name_en }}
            </td>
            <td class="ts-bg-gray-100 ts-px-2 ts-py-1 ts-text-center">
              {{ detail.quantity }}
            </td>
            <td class="ts-bg-gray-100 ts-px-6 ts-py-1 ts-text-center">
              <div class="ts-w-full ts-flex ts-justify-between">
                <p class="mb-0">{{ $defaultCurrencyWithCode(detail.cost) }}</p>
              </div>
            </td>
            <td class="ts-bg-gray-100 ts-px-6 ts-py-1 ts-text-center">
              <div class="ts-w-full ts-flex ts-justify-between">
                <p class="mb-0">{{ $defaultCurrencyWithCode((detail.cost * detail.quantity)) }}</p>
              </div>
            </td>
            <td class="ts-bg-gray-100 ts-px-2 ts-py-1">{{ detail.remarks }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReplacementSerialHistory',
  props: ['value'],
}
</script>